import { inject, Injectable } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AppSelectors } from '../store/app/app.selectors';
import { catchError, filter, first, map, of, timeout } from 'rxjs';
import { SetSessionExpired } from '../store/app/app.actions';

@Injectable({ providedIn: 'root' })
class OffcanvasAccessGuardService {
  readonly store = inject(Store);
  readonly router = inject(Router);

  canActivate() {
    return this.store.select(AppSelectors.hasNavigationAccess).pipe(
      filter((hasAccess) => hasAccess !== undefined),
      first(),
      timeout(10000), // 10 second timeout to prevent hanging if state never loads
      catchError(() => {
        // If the state never loads, trigger session expired flow
        this.store.dispatch(new SetSessionExpired(true));
        return of(false);
      }),
      map((hasAccess) => {
        if (!hasAccess) {
          // Redirect to dashboard when user doesn't have navigation access
          this.router.navigate(['/dashboard']);
          return false;
        }
        return true;
      }),
    );
  }
}

export const canActivateOffcanvas: CanActivateFn = () => {
  return inject(OffcanvasAccessGuardService).canActivate();
};
